import ReactTooltip from "react-tooltip";
import {
  DKLabel,
  DKLine,
  DKButton,
  Toggle,
  DKExpandableWrapper,
  showToast,
  TOAST_TYPE
} from "deskera-ui-library";
import RouteManager from "../../managers/RouteManager";
import { useEffect, useState } from "react";
import {
  deepClone,
  removeDelayedLoader,
  showDelayedLoader,
} from "../../utility/Utility";
import CompanyDetailService from "../../services/CompanyDetailService";
import PermissionUtils, { ACTION, MODULE } from "../user-permissions/PermissionUtils";

function NotificationSetting(props) {
  const [notifications, setNotifications] = useState({});
  const [notificationType, setNotificationType] = useState([]);
  const [sectionExpanded, setSectionExpanded] = useState({});

  useEffect(() => {
    getTenantNotificationSettings();
  }, []);

  const getTenantNotificationSettings = () => {
    const timeout = showDelayedLoader();
    CompanyDetailService.getTenantNotificationSettings().then((response) => {
      handleAPIResponse(timeout, response, 'get');
    });
  };

  const changeSetting = (setting, index) => {
    const updatedSetting = { ...setting, value: !setting.value };
    const updatedNotifications = deepClone(notifications);
    updatedNotifications.settings.splice(index, 1, updatedSetting);
    setNotifications(updatedNotifications);
  };

  const updateNotificationSettings = () => {
    const timeout = showDelayedLoader();
    CompanyDetailService.setTenantNotificationSettings(notifications).then(
      (response) => {
        handleAPIResponse(timeout, response, 'update');
      }
    ).catch(err => {
      showToast(
        'Error Updating Notification Settings Please Try Again',
        TOAST_TYPE.FAILURE
      );
      console.log(err);
    });
  };

  const handleAPIResponse = (timeout, response, type) => {
    if (response && response.settings) {
      const types = [];
      response.settings.map((setting) => {
        if (!types.includes(setting.type)) {
          types.push(setting.type);
        }
      });
      setNotificationType(types);
      setNotifications(response);
      if (type === "update") {
        showToast(
          "Notification Settings Updated Successfully",
          TOAST_TYPE.SUCCESS
        );
      }
    } else {
      setNotificationType(deepClone(notificationType));
      showToast(
        `Error ${type === "get" ? "Getting" : "Updating"} Notification Settings Please Try Again`,
        TOAST_TYPE.FAILURE
      );
    }
    removeDelayedLoader(timeout);
  };

  const onSectionExpandCollapse = (type) => {
    const sectionExpandedUpdate = deepClone(sectionExpanded);
    sectionExpandedUpdate[type] = !sectionExpandedUpdate[type];
    setSectionExpanded(sectionExpandedUpdate);
  };

  return (
    <>
      <ReactTooltip type="dark" place="right" html={true} effect="solid" />
      <div className="parent-width">
        <DKLabel
          text={`Notification Settings`}
          className="fw-m fs-l p-h-xxl p-v-l"
        />
        {notificationType.map((type) => {
          return (
            <div key={type} className="parent-width bg-white border-radius-s card-shadow mb-l"
            style={{
              pointerEvents: PermissionUtils.hasAccess(MODULE.COMPANY_SETTINGS, [ACTION.EDIT]) ? "":"none",
              opacity: PermissionUtils.hasAccess(MODULE.COMPANY_SETTINGS, [ACTION.EDIT]) ? "1":"0.9"
            }}>
            <DKExpandableWrapper
              title={`${type} Notification Settings`}
              className="collapsable"
              expanded={sectionExpanded[type] !== false}
              headerStyle={{ padding: "20px" }}
              onClick={() => {
                onSectionExpandCollapse(type);
              }}
            >
              <div className="parent-width bg-white border-radius-s card-shadow mb-l">
                <ReactTooltip
                  type="dark"
                  place="right"
                  html={true}
                  effect="solid"
                />
                <DKLine className="bg-line-2" />
                <div className="p-l">
                  <div style={{ display: "flex", flexWrap: "wrap" }}>
                    {notifications != null &&
                      notifications.settings &&
                      notifications.settings.map((setting, index) => {
                        return setting.type.toLowerCase() ===
                          type.toLowerCase() ? (
                          <div className="row m-v-m" key={setting.id}>
                            <Toggle
                              className="mr-l border-n"
                              isOn={setting.value}
                              onChange={() => changeSetting(setting, index)}
                            />
                            <span className="fs-l fw-h mr-l">
                              {setting.name}
                            </span>
                            <span>{setting.description}</span>
                          </div>
                        ) : null;
                      })}
                  </div>
                </div>
              </div>
            </DKExpandableWrapper>
            </div>
          );
        })}
        <div className="d-flex p-v-l">
          <DKButton
            title="Update"
            className="border-m bg-app text-white mr-r"
            disabled={!PermissionUtils.hasAccess(MODULE.COMPANY_SETTINGS, [ACTION.EDIT])}
            onClick={() => {
              updateNotificationSettings();
            }}
          />
          <DKButton
            title="Cancel"
            className="border-m bg-gray1"
            onClick={() => {
              RouteManager.navigateToHome();
            }}
          />
        </div>
      </div>
    </>
  );
}
export default NotificationSetting;
